import React,{useState,useRef,useEffect} from 'react'
import Footer from '../inc/Footer'
import WathListComp from '../inc/WathListComp'
import axios from "axios";
import "../inc/GlobalVars";

function WatchList() {

  const [watchListItems, setWatchListItems] = useState([]);
 
  const user_id = localStorage.getItem('userId');
  function getWatchList() {
    axios.get(global.apiUrl + "/getUserWatchList/"+user_id).then(function (response) {
      const watchData = response.data["data"];
      console.log(watchData);
      setWatchListItems(watchData);
    });
  }



  useEffect(() => {
    //getWatchList(); // Fetch auction list immediately when component mounts
    const intervalId = setInterval(() => {
      getWatchList();// Refresh auction list every 5 seconds
    }, 2000);

    return () => {
      clearInterval(intervalId); // Clear the interval when component unmounts
    };
  }, []);
  const updateWatchlist = () => {
    getWatchList(); 
  };


  return (
    <div>
      <div className='container'>
            <div className='row'>
            <div className="col-md-12 mb-2  mt-5">
            <h1>Watchlist</h1>
            </div>
            </div>
        </div>
        
        {
              watchListItems.length > 0 ? (
                watchListItems.map((ac, key) => (
                  <WathListComp
                    key={key}
                    
                    reg_number={ac.reg_number}
                    case_name={ac.case_name}
                    insurer_name={ac.insurer_name}
                    make_name={ac.make_name}
                    model={ac.model}
                    expiry_date={ac.expiry_date}
                    expiry_time={ac.expiry_time}
                    featured_image={ac.featured_image}
                    min_bid={ac.bid_amount}
                    vehicle_id={ac.vehicle_id}
                    rc_availability={ac.rc_availability}
                    owners={ac.ownership}
                location={ac.state}
                variant = {ac.variant}
                year={ac.manufacture_year}
                transmission = {ac.transmission}
                cname = {ac.name}
                cmobile = {ac.mobile}
                bid_max_amount = {ac.bid_amount_max}
                bid_win_status = {ac.bid_win_status}
                can_bid = {ac.can_bid}
                    updateWatchlist={updateWatchlist}
                  />
                ))
              ) : (
                <h2>No Items In Watchlist</h2>
              )
              }
        <Footer/>
    </div>
  )
}

export default WatchList